/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ar as Ar,
  rec_AvatarPersona as AvatarPersona,
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_kr as kr,
  rec_kx as kx,
} from "../../runtime/index.jsx";
export function BuscarConversacion(e) {
  let t = (0, ReactCompiler.c)(40),
    {
      value: n,
      onChange: r,
      opciones: i,
      placeholder: a,
      sugerencia: o,
      disabled: s,
      id: c,
      extra: l,
    } = e,
    u;
  t[0] === i
    ? (u = t[1])
    : ((u = i === void 0 ? [] : i), (t[0] = i), (t[1] = u));
  let f = u,
    p = a === void 0 ? `Escribí para buscar…` : a,
    m = o === void 0 ? null : o,
    h = s !== void 0 && s,
    _ = l === void 0 ? null : l,
    [v, y] = (0, React.useState)(``),
    [b, x] = (0, React.useState)(!1),
    S = (0, React.useRef)(null),
    C;
  t[2] !== _ || t[3] !== f || t[4] !== n
    ? ((C =
        f.find((e) => String(e.value) === String(n)) ??
        (n !== `` && n != null ? (_?.(String(n)) ?? null) : null)),
      (t[2] = _),
      (t[3] = f),
      (t[4] = n),
      (t[5] = C))
    : (C = t[5]);
  let w = C,
    T;
  (t[6] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((T = () => x(!1)), (t[6] = T))
    : (T = t[6]),
    kx(b, S, T));
  let E;
  if (t[7] !== _ || t[8] !== f || t[9] !== m || t[10] !== v) {
    let e = v.trim().toLowerCase(),
      n = (
        e
          ? f.filter((t) => t.label.toLowerCase().includes(e))
          : m
            ? f.filter(m)
            : f
      ).slice(0, 30),
      r;
    t[12] !== _ || t[13] !== v
      ? ((r = _?.(v.trim())), (t[12] = _), (t[13] = v), (t[14] = r))
      : (r = t[14]);
    let i = r;
    ((E =
      i && !n.some((e) => String(e.value) === String(i.value)) ? [...n, i] : n),
      (t[7] = _),
      (t[8] = f),
      (t[9] = m),
      (t[10] = v),
      (t[11] = E));
  } else E = t[11];
  let D = E,
    O;
  t[15] === r
    ? (O = t[16])
    : ((O = function (e) {
        (r(e.value), y(``), x(!1));
      }),
      (t[15] = r),
      (t[16] = O));
  let k = O,
    A = c ? `${c}-lista` : void 0,
    j = v || (b ? `` : (w?.label ?? ``)),
    M = w ? w.label : p,
    N,
    P;
  t[17] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((N = () => x(!0)),
      (P = (e) => {
        (y(e.target.value), x(!0));
      }),
      (t[17] = N),
      (t[18] = P))
    : ((N = t[17]), (P = t[18]));
  let F;
  t[19] !== k || t[20] !== D
    ? ((F = (e) => {
        (e.key === `Escape` && x(!1),
          e.key === `Enter` && D.length === 1 && (e.preventDefault(), k(D[0])));
      }),
      (t[19] = k),
      (t[20] = D),
      (t[21] = F))
    : (F = t[21]);
  let I;
  t[22] !== b ||
  t[23] !== h ||
  t[24] !== c ||
  t[25] !== A ||
  t[26] !== j ||
  t[27] !== M ||
  t[28] !== F
    ? ((I = (
        <input
          id={c}
          type={`text`}
          role={`combobox`}
          aria-expanded={b}
          aria-controls={A}
          autoComplete={`off`}
          disabled={h}
          value={j}
          placeholder={M}
          onFocus={N}
          onChange={P}
          onKeyDown={F}
          className={Lo}
        />
      )),
      (t[22] = b),
      (t[23] = h),
      (t[24] = c),
      (t[25] = A),
      (t[26] = j),
      (t[27] = M),
      (t[28] = F),
      (t[29] = I))
    : (I = t[29]);
  let L;
  t[30] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((L = (
        <Ar
          className={`pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-(--text)`}
        />
      )),
      (t[30] = L))
    : (L = t[30]);
  let R;
  t[31] !== b || t[32] !== k || t[33] !== c || t[34] !== n || t[35] !== D
    ? ((R = b && (
        <AvatarPersona
          anclaRef={S}
          className={`rounded-2xl border border-(--border) bg-(--bg) py-1 shadow-2xl`}
          children={
            <ul
              id={c ? `${c}-lista` : void 0}
              children={
                D.length === 0 ? (
                  <li
                    className={`px-3 py-2 text-sm text-(--text)`}
                    children={`Nada coincide`}
                  />
                ) : (
                  D.map((e) => (
                    <li
                      key={e.value}
                      children={
                        <button
                          type={`button`}
                          onClick={() => k(e)}
                          className={`flex w-full items-center gap-2 px-3 py-2 text-left text-sm text-(--text-h) hover:bg-(--accent-bg)`}
                          children={[
                            String(e.value) === String(n) &&
                              (0, JSXRuntime.jsx)(kr, {
                                className: `h-3.5 w-3.5 shrink-0 text-(--accent)`,
                              }),
                            <span className={`truncate`} children={e.label} />,
                          ]}
                        />
                      }
                    />
                  ))
                )
              }
            />
          }
        />
      )),
      (t[31] = b),
      (t[32] = k),
      (t[33] = c),
      (t[34] = n),
      (t[35] = D),
      (t[36] = R))
    : (R = t[36]);
  let z;
  return (
    t[37] !== I || t[38] !== R
      ? ((z = <div className={`relative`} ref={S} children={[I, L, R]} />),
        (t[37] = I),
        (t[38] = R),
        (t[39] = z))
      : (z = t[39]),
    z
  );
}
